module.exports = __webpack_public_path__ + "static/media/dec-tutorial-dl-front.861cde08.gif";